var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "88",
        "height": "88",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('defs', [_c('linearGradient', {
      attrs: {
        "x1": "50%",
        "y1": "0%",
        "x2": "50%",
        "y2": "100%",
        "id": "a"
      }
    }, [_c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColorShowTop)",
        "offset": "0%"
      }
    }), _c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColorShowBot)",
        "offset": "100%"
      }
    })])]), _c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('circle', {
      attrs: {
        "stroke": "url(#a)",
        "stroke-width": "2",
        "cx": "44",
        "cy": "44",
        "r": "43"
      }
    }), _c('path', {
      attrs: {
        "d": "M42.335 28.03c-7.333 0-13.333 6-13.333 13.332 0 7.334 6 13.334 13.333 13.334 7.334 0 13.334-6 13.334-13.334 0-7.4-6-13.333-13.334-13.333zm-4.933 6.332c-.333.134-.6.267-.867.467-.266.2-.533.4-.8.667-.2.2-.466.466-.6.733-.2.267-.333.6-.466.867-.134.267-.4.4-.667.267-.267-.134-.4-.4-.267-.667.134-.334.334-.734.6-1.067.416-.68.987-1.25 1.667-1.667.333-.2.667-.4 1.067-.6.266-.133.6 0 .666.267.067.333-.066.6-.333.733zm13.8 11.8c-.333.734-.733 1.4-1.333 2-.6.6-1.267 1.067-2 1.334-.734.333-1.534.466-2.4.466-.267 0-.534-.266-.534-.533s.2-.533.534-.533a5.35 5.35 0 002-.4c.6-.267 1.2-.6 1.666-1.134.534-.466.867-1.066 1.134-1.666.266-.6.4-1.334.4-2 0-.267.266-.534.533-.534s.533.267.533.534a9.527 9.527 0 01-.533 2.466zm8.133 9.467l-3.733-3.867c-.4-.4-.867-.6-1.4-.6-.533 0-1 .2-1.4.6-.8.8-.8 2.067 0 2.867l3.733 3.867c.4.4.867.6 1.4.6.534 0 1-.2 1.4-.6.8-.8.8-2.067 0-2.867z",
        "fill": "var(--homeIconCenterColor)",
        "fill-rule": "nonzero"
      }
    })])]));
  }
};